import { useCallback, useEffect, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  betSlipInitRedux,
  getAndRemoveMustOpenBetslipFromLS
} from 'utils/betslip/betslip';
import { loadLadder } from 'utils/betslip/odd-formats-helper';
import { getOddsFormat } from 'utils/betslip/odds-format';
import LS from 'utils/bom-dom-manipulation/local-storage';
import { ODD_FORMATS } from 'utils/constants/betslip/odd-formats';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { GLOBALS } from 'utils/generic/global-variables';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { isMobile } from 'utils/is-mobile';
import { EBetslipPage } from 'interfaces/bet-data';
import { EBetslipBetType, EBetslipType } from 'interfaces/betslip';
import { toggleBetslip } from 'newelements/_Betslip/managers/ToggleManager/toggle-betslip-options';
import { useBetslipConfigsContext } from 'newelements/_Betslip/providers/configs-provider';
import {
  setActiveTabPage,
  setElementAbsent,
  setElementPresent,
  setFreezeTabChange,
  setMustOpen,
  setType
} from 'store/actions';
import {
  getAllLsBets,
  getBetslipType,
  getFreezeTabChange,
  getLadderLoaded,
  getOddFormat,
  getOpenBetsCount
} from 'store/selectors/betslip';
import { getIsLoggedIn } from 'store/selectors/user-data';

const openBetsByDefault = SpringConfigs.OPEN_BETS_BY_DEFAULT;

export const BetslipConfigManager = (): null => {
  const history = useHistory();
  const dispatch = useDispatch();

  const oddFormat = useSelector(getOddFormat);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const betslipType = useSelector(getBetslipType);
  const ladderLoaded = useSelector(getLadderLoaded);
  const openBetsCount = useSelector(getOpenBetsCount);
  const allBetsCount = useSelector(getAllLsBets).length;
  const freezeTabChange = useSelector(getFreezeTabChange);

  const { floatingMode } = useBetslipConfigsContext().static;

  const selectBetslipTab = useCallback(
    (index: EBetslipPage) => {
      if (freezeTabChange) {
        dispatch(setFreezeTabChange(false));
      } else {
        dispatch(setActiveTabPage(index));
      }
    },
    [freezeTabChange]
  );

  useLayoutEffect(() => {
    const initialOddFormat = {
      ...ODD_FORMATS.find(format => {
        return format.id === getOddsFormat();
      })
    };

    const { id } = initialOddFormat;

    if (!GLOBALS.oddsFormat) {
      loadLadder(id);
    }
  }, [ladderLoaded, oddFormat]);

  useEffect(() => {
    betSlipInitRedux();
    dispatch(setElementPresent('betslip'));

    openBetsCount &&
      allBetsCount === 0 &&
      dispatch(setActiveTabPage(EBetslipPage.OPEN_BETS));

    if (!floatingMode) {
      GLOBALS.betslipElementsCount += 1;
    }

    const mustOpenLS = getAndRemoveMustOpenBetslipFromLS();

    if (mustOpenLS) {
      dispatch(setMustOpen(true));
      isMobile() && LS.removeItem(storageKeyName('betslip', 'MUST_OPEN'));
    }

    return () => {
      dispatch(setElementAbsent('betslip'));
      dispatch(setMustOpen(false));

      if (!floatingMode) {
        GLOBALS.betslipElementsCount -= 1;
      }
    };
  }, []);

  useLayoutEffect(() => {
    let search = '';

    return history.listen(data => {
      if (
        search.includes('booking_id') &&
        !data.search.includes('booking_id')
      ) {
        toggleBetslip(false);
      }

      search = data.search;
    });
  }, []);

  useLayoutEffect(() => {
    if (betslipType === EBetslipType.ADVANCED) {
      dispatch(setType(EBetslipBetType.SINGLE));
    }
  }, [betslipType]);

  useLayoutEffect(() => {
    if (isLoggedIn) {
      if (isMobile()) {
        if (openBetsCount && !allBetsCount) {
          selectBetslipTab(EBetslipPage.OPEN_BETS);
        }
      } else {
        if (openBetsByDefault && openBetsCount && !allBetsCount) {
          selectBetslipTab(EBetslipPage.OPEN_BETS);
        }
      }
    }
  }, [allBetsCount, isLoggedIn, openBetsCount]);

  // useLayoutEffect(() => {
  //   if (allBetsCount < 2 && !getBookBetIdFromLs()) {
  //     dispatch(setType(''));
  //   }
  // }, [allBetsCount]);

  return null;
};
